import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import { Firebase } from '../../lib/firebase';

import {
  //  getAllRoomsLogs,
  getRoomLog,
  getRoomLogsRange,
  getRoomLogCount,
  getFilteredRoomLogs,
  getBotUsers,
} from '../../actions/admin';

import { getTimeOffset } from '../../actions/member';

class AdminLogs extends Component {
  static propTypes = {
    Layout: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    member: PropTypes.shape({
      role: PropTypes.shape({}),
    }),
    admin: PropTypes.shape({
      allRoomsLogs: PropTypes.arrayOf(PropTypes.shape({})),
      allRoomsLogsLoading: PropTypes.bool,
      roomData: PropTypes.shape({}),
      filteredRoomsLogs: PropTypes.shape({}),
      filteredRoomsLogsLoading: PropTypes.bool,
      roomsPlayedCount: PropTypes.number,
    }),
    match: PropTypes.shape({ params: PropTypes.shape({}) }),
    // fetchAllRoomsLogs: PropTypes.func.isRequired,
    fetchTimeOffset: PropTypes.func.isRequired,
    fetchRoomLog: PropTypes.func.isRequired,
    fetchRoomLogCount: PropTypes.func.isRequired,
    fetchRoomLogsRange: PropTypes.func.isRequired,
    fetchFilteredRoomLogs: PropTypes.func.isRequired,
    fetchBots: PropTypes.func.isRequired,
    bots: PropTypes.shape({}),
    //  showNotification: PropTypes.func.isRequired,
    searchUid: PropTypes.string,
  }

  static defaultProps = {
    searchUid: null,
    match: null,
    member: {},
    admin: {},
    bots: {},
  }

  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };

    this.fetchRoomLog = this.fetchRoomLog.bind(this);
  }

  // componentDidMount = () => {
  //   Firebase.auth().onAuthStateChanged((user) => {
  //     const { member, fetchBots } = this.props;

  //     if (user) {
  //       //  if (member && member.role === 'admin') {
  //       if (member && (member.role === 'admin' || member.role === 'tester')) {
  //         //  this.fetchAllRoomsLogs();
  //         this.fetchRoomLogCount();
  //         this.fetchFilteredRoomLogs();
  //         fetchBots();
  //         //  this.fetchRoomLogsRange(1, 50);
  //       } else {
  //         //  history.push('/');
  //       }
  //     } else {
  //       //  console.log('no user');
  //     }
  //   });

  // }

  componentDidMount = () => {
    const { member, fetchBots, searchUid, fetchTimeOffset } = this.props;
    if (!searchUid) {
      this.fetchRoomLogCount();
    } else {
      this.fetchFilteredRoomLogs(
        searchUid,
        'userId',
        [],
        [],
        "",
        "",
        [],
        [],
        "",
        "",
        "",
        "",
        "",
        "",
        false,
        false,
        false,
        false,
        false,
        Date.parse(new Date(Date.now() - 24 * 60 * 60 * 1000)),
        Date.parse(new Date()),
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      );
    }
    // this.fetchRoomLogCount();
    fetchBots();

    fetchTimeOffset();
  }

  // componentDidUpdate = (prevProps) => {
  //   const { member, fetchBots, searchUid } = this.props;
  //   if (member.uid && member.uid !== prevProps.member.uid) {
  //     // this.fetchRoomLogCount();
  //     if (!searchUid) {
  //       this.fetchRoomLogCount();
  //       //this.fetchFilteredRoomLogs();
  //     } else {

  //       this.fetchFilteredRoomLogs(
  //         searchUid,
  //         'userId',
  //         [],
  //         [],
  //         "",
  //         "",
  //         [],
  //         [],
  //         "",
  //         "",
  //         "",
  //         "",
  //         "",
  //         "",
  //         false,
  //         false,
  //         false,
  //         false,
  //         false,
  //         Date.parse(new Date(Date.now() - 24 * 60 * 60 * 1000)),
  //         Date.parse(new Date()),
  //         "",
  //         "",
  //         "",
  //         "",
  //         "",
  //         "",
  //         "",
  //         "",
  //       );
  //     }
  //     fetchBots();
  //   }
  // }

  fetchRoomLogCount = () => {
    const { fetchRoomLogCount } = this.props;

    fetchRoomLogCount().then((res) => {
      if (res && res.data) {
        this.fetchRoomLogsRange(res.data - 50, res.data);
      }
    });
  }

  fetchRoomLogsRange = (start, end) => {
    const { fetchRoomLogsRange } = this.props;

    fetchRoomLogsRange(start, end).then(() => {
      //  console.log(res);
    });
  }

  fetchFilteredRoomLogs = (
    filter,
    filterType,
    filterMinValue,
    filterPlatform,
    filterSpeed,
    filterGames,
    filterBet,
    filterGameType,
    filterAmountOfPlayer,
    filterCloseReason,
    filterByTimeBetween,
    filterByTimeBetweenTime,
    filterBots,
    filterTournament,
    showActiveRooms,
    showMergedRooms,
    showAutoPlayRooms,
    excludeLeftBeforeStartRooms,
    onlyPenaltyRooms,
    startDate,
    endDate,
    winPointsFrom,
    winPointsTo,
    winCoinsFrom,
    winCoinsTo,
    lossPointsFrom,
    lossPointsTo,
    lossCoinsFrom,
    lossCoinsTo,
  ) => {
    const { fetchFilteredRoomLogs } = this.props;
    fetchFilteredRoomLogs(
      filter,
      filterType,
      filterMinValue,
      filterPlatform,
      filterSpeed,
      filterGames,
      filterBet,
      filterGameType,
      filterAmountOfPlayer,
      filterCloseReason,
      filterByTimeBetween,
      filterByTimeBetweenTime,
      filterBots,
      filterTournament,
      showActiveRooms,
      showMergedRooms,
      showAutoPlayRooms,
      excludeLeftBeforeStartRooms,
      onlyPenaltyRooms,
      startDate,
      endDate,
      winPointsFrom,
      winPointsTo,
      winCoinsFrom,
      winCoinsTo,
      lossPointsFrom,
      lossPointsTo,
      lossCoinsFrom,
      lossCoinsTo,
    ).then(() => {
    });
  }

  fetchRoomLog(roomId) {
    const { fetchRoomLog } = this.props;

    fetchRoomLog(roomId).then(() => {
    });
  }

  render = () => {
    const {
      Layout,
      member,
      admin,
      bots,
      searchUid,
      offset,
      fetchBots,
    } = this.props;

    // console.log('botsbotsbots', bots);

    const {
      error,
    } = this.state;

    return (
      <Layout
        error={error}
        member={member}
        allRooms={admin.allRoomsLogs}
        allRoomsLoading={admin.allRoomsLogsLoading}
        roomData={admin.roomData}
        roomsPlayedCount={admin.roomsPlayedCount}
        filteredRoomsLogs={admin.filteredRoomsLogs}
        filteredRoomsLogsLoading={admin.filteredRoomsLogsLoading}
        totalRoomCount={admin.totalRoomCount}
        //  fetchAllRoomsLogs={this.fetchAllRoomsLogs}
        fetchBots={fetchBots}
        fetchRoomLog={this.fetchRoomLog}
        fetchUserCount={this.fetchUserCount}
        fetchRoomLogsRange={this.fetchRoomLogsRange}
        fetchFilteredRoomLogs={this.fetchFilteredRoomLogs}
        bots={bots}
        searchUid={searchUid}
        offset={offset}
      />
    );
  }
}

const mapStateToProps = state => ({
  member: state.member || {},
  admin: state.admin || {},
  bots: state.admin.bots || {},
});

const mapDispatchToProps = {
  //  fetchAllRoomsLogs: getAllRoomsLogs,
  fetchRoomLog: getRoomLog,
  fetchRoomLogsRange: getRoomLogsRange,
  fetchFilteredRoomLogs: getFilteredRoomLogs,
  //  fetchFilteredUsers: getFilteredUsers,
  fetchRoomLogCount: getRoomLogCount,
  fetchBots: getBotUsers,
  fetchTimeOffset: getTimeOffset,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminLogs));
